
const BoletoSegment = () => {
    return (
        <></>
    );
}

export default BoletoSegment;